import { FieldError } from 'react-hook-form';

export enum ValidationStatus {
    INVALID = 'invalid',
    VALID = 'valid',
    UNKNOWN = 'unknown'
}

const validationDecoration = (state: {
    invalid: boolean;
    isDirty: boolean;
    isTouched: boolean;
    error?: FieldError;
}) => {
    if (state.error) {
        return ValidationStatus.INVALID;
    }
    if (state.isTouched) {
        return ValidationStatus.VALID;
    }
    return ValidationStatus.UNKNOWN;
};

export const getValidationStatus = (error: string) => {
    if (error) {
        return ValidationStatus.INVALID;
    }

    return ValidationStatus.UNKNOWN;
};

export default validationDecoration;
